import { Button } from '../../ui/button';
import {
  DeliveryQueueSelector,
  type DeliveryQueueSelectorProps,
} from './delivery-queue-selector';

export function DeliveryQueueSelectorButton(props: DeliveryQueueSelectorProps) {
  return (
    <Button variant="outline" className="p-0 h-fit">
      <DeliveryQueueSelector {...props} />
    </Button>
  );
}

export default DeliveryQueueSelectorButton;
